import React from "react";
import { Heading, Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Button, ButtonProps } from "@campgladiator/cgui-core.atoms.button";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import { Loader } from "@campgladiator/cgui-core.atoms.loader";
import styles from "./table-header.module.scss";

type TableHeaderButtonProp = {
  isLoading?: boolean;
} & ButtonProps;

export type TableHeaderProps = {
  buttons?: TableHeaderButtonProp[];
  deviceWidth: number;
  iconName?: string;
  tableCornerTitle?: string;
  tableName: string;
  tableSubTitle?: string;
};

const TableHeader = ({
  deviceWidth,
  buttons,
  tableName,
  tableSubTitle,
  tableCornerTitle,
  iconName,
}: TableHeaderProps) => {
  const tableHeaderClass =
    buttons?.length === 1
      ? styles.tableHeaderSingleButton
      : !buttons && !!tableCornerTitle
      ? styles.tableHeaderWithCorner
      : styles.tableHeader;

  return (
    <header className={tableHeaderClass}>
      <div className={styles.title}>
        <Heading className={styles.tableName} type="h3">
          {tableName}
          {tableSubTitle && (
            <Paragraph weight="book">{tableSubTitle}</Paragraph>
          )}
        </Heading>
        {iconName && (
          <Icon.Monochrome name={iconName} className={styles.tableIcon} />
        )}
      </div>
      {!buttons && tableCornerTitle && (
        <Heading className={styles.tableCornerTitle} type="h3">
          {tableCornerTitle}{" "}
          {tableSubTitle && <Paragraph weight="book">&nbsp;</Paragraph>}
        </Heading>
      )}
      {buttons?.map((btn) => (
        <div className={styles.buttons}>
          <Button
            emphasis={btn.emphasis ?? "secondary"}
            icon={btn.icon}
            size={btn.size}
            variation={btn.variation ?? "solid"}
            onClick={btn.onClick}
            disabled={btn.disabled}
          >
            {btn.isLoading ? (
              <Loader className={styles.loader} />
            ) : (
              btn.children
            )}
          </Button>
        </div>
      ))}
    </header>
  );
};

export default TableHeader;
